// A '.tsx' file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React from 'react';
interface ToolbarHeaderProps extends ReactProps {
    title: string;
}

const ToolbarHeader = (props: ToolbarHeaderProps) => (
    <div className="panel-primary toolbar-header">
        <div className="panel-heading">{props.title}</div>
        <div className="ctnt-main">
                {props.children}
        </div>
    </div>
);

export default ToolbarHeader;